import React, { Component } from 'react'
import { Container,Typography,Card,Grid,Divider,TextField,Button,Box,Link, Paper,} from '@mui/material';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import DeleteIcon from '@mui/icons-material/Delete';
import AdjustIcon from '@mui/icons-material/Adjust';
import { useNavigate,useLocation } from 'react-router-dom';
import base_url from './base_url';


export class FinalOrder extends Component {
    constructor(props) {
      super(props)
    
      this.state = {
        firstname:"",
        lastname:"",
        phone:"",
        email:"",
date:"",
postalcode:"",
city:"",
adress:"",
state:"",
country:"",


itemsSelectedForPurchase : []

      }
      this.handlechange=this.handlechange.bind()
    }


    componentDidMount(){
      if(this.props.location.state!==null){
        this.setState({
          itemsSelectedForPurchase : this.props.location.state.data
        })
      }
    }





pay=()=>{
let object  = {}
object.firstname = this.state.firstname
object.lastname = this.state.lastname
object.phone = this.state.phone
object.email = this.state.email
object.delivery_date = this.state.date
object.postalcode = this.state.postalcode
object.city = this.state.city
object.adress = this.state.adress
object.state = this.state.state
object.country = this.state.country

let itemsData = this.state.itemsSelectedForPurchase;
const sum = itemsData.reduce((accumulator, currentValue) => {
  return accumulator + currentValue.price;
}, 0);

if(this.state.firstname!=="" && this.state.lastname!=="" && this.state.phone!=="" && this.state.email!=="" && this.state.delivery_date!=="" && this.state.postalcode!=="" && this.state.city!=="" && this.state.adress!=="" && this.state.state!=="" && this.state.country!=="" ){
    var rzp1 = new window.Razorpay({
    key: 'rzp_test_kJ4tIVb7nNKFqW',
    amount: sum * 100, 
    currency: 'INR',
    name: 'Khicha rojes marketing.',
    description: 'Retail product selling',
    handler: function(response) {
       // alert(response.razorpay_payment_id);

       let email = localStorage.getItem('email');
       if(email!==null){
       fetch(
         `${base_url.base_url}/orderList/addNewOrder`,
         {
           headers: {
             "content-type": "application/json",
           },
           method: "post",
           body : JSON.stringify({
            items : itemsData,
            address : object,
            status  : 'Pending',
            payment_details  : response,
            cust_email : email
           })
         }
       )
         .then((res) => {
           return res.json();
         })
         .then((result) => {
          this.props.navigate('/orderList')
         });


////customer_email : String,
fetch(
  `${base_url.base}/transaction/recodeTransaction`,
  {
    headers: {
      "content-type": "application/json",
    },
    method: "post",
    body : JSON.stringify({
customer_email : email,
amount: sum,
response_data : response ,
payment_status : true,
    })
  }
)
  .then((res) => {
    return res.json();
  })
  .then((result) => {
  });


       }
    }
});
rzp1.open();
}else{
  alert('Fill All Fields')
}
}



payCash=()=>{
  let object  = {}
  object.firstname = this.state.firstname
  object.lastname = this.state.lastname
  object.phone = this.state.phone
  object.email = this.state.email
  object.delivery_date = this.state.date
  object.postalcode = this.state.postalcode
  object.city = this.state.city
  object.adress = this.state.adress
  object.state = this.state.state
  object.country = this.state.country
  let itemsData = this.state.itemsSelectedForPurchase;

  if(this.state.firstname!=="" && this.state.lastname!=="" && this.state.phone!=="" && this.state.email!=="" && this.state.delivery_date!=="" && this.state.postalcode!=="" && this.state.city!=="" && this.state.adress!=="" && this.state.state!=="" && this.state.country!==""){


         let email = localStorage.getItem('email');
         if(email!==null){
         fetch(
           `${base_url.base_url}/orderList/addNewOrder`,
           {
             headers: {
               "content-type": "application/json",
             },
             method: "post",
             body : JSON.stringify({
              items : itemsData,
              address : object,
              status  : 'Pending',
              payment_details  : {'mode' : 'Cash'},
              cust_email : email
             })
           }
         )
           .then((res) => {
             return res.json();
           })
           .then((result) => {
           this.props.navigate('/orderList')
           });
       
         }
  
        }else{
          alert("Fill All Fields")
        }
   
  }
  

handlechange=(e)=>{
this.setState({[e.target.name]:e.target.value})
}


  render() {
      const sum = this.state.itemsSelectedForPurchase.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.price;
    }, 0);
    return (
      <div>
      <Box sx={{backgroundColor:'#f1f4f6',minHeight:600}}>
      <Box sx={{paddingLeft:{xs:0,sm:3},paddingRight:{xs:0,sm:3},mt:3,width:'100%'}}>
      <Container maxWidth='xl'>
      <Box>
  <br/>
  <br/>
  <br/>
      
  <Grid container rowSpacing={1} columnSpacing={{ xs: 2, sm: 2, md:2 }}>
  <Grid item xs={12} sm={12} md={9}>
   <Box sx={{backgroundColor:'white',minHeight:300}}>
   <br/>
   <Box sx={{ml:2,mt:1,mr:2}}>
   <Typography sx={{fontSize:19,fontWeight:'500',fontFamily:'serif',color:'#c7167a'}}>Please enter your delivery address OR home address</Typography>
   </Box>
   <Grid container rowSpacing={2} columnSpacing={{ xs: 2, sm: 3, md: 9 }}>
  <Grid item xs={12} sm={12} md={6}>
    <Box sx={{m:2}}>
    <Typography sx={{fontSize:14,fontWeight:'bold',ml:0.1}}>First name *</Typography>
    <TextField
    error={this.state.firstname==""}
    InputProps={{sx:{fontSize:12}}}
    name="firstname"
    value={this.state.firstname}
    onChange={this.handlechange}
    fullWidth
    id="filled-password-input"
placeholder='Name'
    type="text"
    autoComplete="current-password"
    variant='standard'

  />
    
    </Box>
  </Grid>
  <Grid item xs={12} sm={12} md={6}>
  <Box sx={{m:2}}>
    <Typography sx={{fontSize:14,fontWeight:'bold',ml:0.1}}>Last name *</Typography>
    <TextField
    fullWidth
    error={this.state.lastname==""}
    name="lastname"
    value={this.state.lastname}
    onChange={this.handlechange}
    id="filled-password-input"
placeholder='Last name'
    type="text"
    autoComplete="current-password"
    variant='standard'
   InputProps={{sx:{fontSize:12}}}
  />
    
    </Box>
  </Grid>
  <Grid item xs={12} sm={12} md={6}>
  <Box sx={{m:2}}>
    <Typography sx={{fontSize:14,fontWeight:'bold',ml:0.1}}>Phone *</Typography>
    <TextField
    fullWidth
    error={this.state.phone==""}
    name="phone"
    value={this.state.phone}
    onChange={this.handlechange}
    id="filled-password-input"
    placeholder='Phone'
    type='tel'
    autoComplete="current-password"
    variant='standard'
   InputProps={{sx:{fontSize:12}}}
  />
    
    </Box>
  </Grid>
  <Grid item xs={12} sm={12} md={6}>
  <Box sx={{m:2}}>
  <Typography sx={{fontSize:14,fontWeight:'bold',ml:0.1}}>Email *</Typography>
  <TextField
  fullWidth
  error={this.state.email==""}
  name="email"
  value={this.state.email}
  onChange={this.handlechange}
  id="filled-password-input"
placeholder='Email'
  type='email'
  autoComplete="current-password"
  variant='standard'
  InputProps={{sx:{fontSize:12}}}
/>
  
  </Box>
  </Grid>
  <Grid item xs={12} sm={12} md={6}>
  <Box sx={{m:2}}>
    <Typography sx={{fontSize:14,fontWeight:'bold',ml:0.1}}>Post code / ZIP *</Typography>
    <TextField
    fullWidth
    error={this.state.postalcode==""}
    value={this.state.postalcode}
    name="postalcode"
    onChange={this.handlechange}
    id="filled-password-input"
     placeholder='Post code / ZIP'
    type='number'
    autoComplete="current-password"
    variant='standard'
   InputProps={{sx:{fontSize:12}}}
  />
    
    </Box>
</Grid>
<Grid item xs={12} sm={12} md={6}>
<Box sx={{m:2}}>
    <Typography sx={{fontSize:14,fontWeight:'bold',ml:0.1}}>City *</Typography>
    <TextField
    fullWidth
    error={this.state.city==""}
    name="city"
    value={this.state.city}
    onChange={this.handlechange}
    id="filled-password-input"
placeholder='City'
    type="text"
    autoComplete="current-password"
    variant='standard'
   InputProps={{sx:{fontSize:12}}}
  />
    
    </Box>
</Grid>
<Grid item xs={12} sm={12} md={6}>
<Box sx={{m:2}}>
    <Typography sx={{fontSize:14,fontWeight:'bold',ml:0.1}}>Address *</Typography>
    <TextField
    fullWidth
    error={this.state.adress==""}
    name="adress"
    value={this.state.adress}
    onChange={this.handlechange}
    id="filled-password-input"
placeholder='Address'
    type="text"
    autoComplete="current-password"
    variant='standard'
   InputProps={{sx:{fontSize:12}}}
  />
    
    </Box>
</Grid>
  <Grid item xs={12} sm={12} md={6}>
  <Box sx={{m:2}}>
  <Typography sx={{fontSize:14,fontWeight:'bold',ml:0.1}}>Expected Delivery date *</Typography>
  <TextField
  fullWidth
  error={this.state.date==""}
  name="date"
  value={this.state.date}
  onChange={this.handlechange}
  id="filled-password-input"
   placeholder='Delivery date'
  type='date'
  autoComplete="current-password"
  variant='standard'
  InputProps={{sx:{fontSize:12}}}
/>
  
  </Box>
   </Grid>
  <Grid item xs={12} sm={12} md={6}>
  <Box sx={{m:2}}>
  <Typography sx={{fontSize:14,fontWeight:'bold',ml:0.1}}>Country*</Typography>
  <TextField
  fullWidth
  error={this.state.country==""}
  name="country"
  value={this.state.country}
  onChange={this.handlechange}
  id="filled-password-input"
  placeholder='Country'
  autoComplete="current-password"
  variant='standard'
  InputProps={{sx:{fontSize:12}}}
/>
  
  </Box>
</Grid>
<Grid item xs={12} sm={12} md={6}>
  <Box sx={{m:2}}>
  <Typography sx={{fontSize:14,fontWeight:'bold',ml:0.1}}>State *</Typography>
  <TextField
  fullWidth
  error={this.state.state==""}
  name="state"
  value={this.state.state}
  onChange={this.handlechange}
  id="filled-password-input"
  placeholder='state/provinance'
  autoComplete="current-password"
  variant='standard'
  InputProps={{
      fontSize:12
  }}
/>
  
  </Box>
</Grid>
</Grid>
   </Box>
  </Grid>
  <Grid item xs={12} sm={12} md={3}>
   <Paper elevation={1} sx={{backgroundColor:'white',minHeight:300}}>
   <Box sx={{backgroundColor:'#5cd1d5',display:'flex',justifyContent:'space-between'}}>
   <Typography sx={{m:2,fontSize:16,fontWeight:'bold'}}>Items</Typography>
   <Typography sx={{m:2,fontSize:16,fontWeight:'bold'}} >Subtotal</Typography>
   </Box>
<Divider/>
<Box sx={{backgroundColor:'#fff',display:'flex',justifyContent:'space-between'}}>
<Typography sx={{m:2,fontSize:15,fontWeight:'700'}}>Total {this.state.itemsSelectedForPurchase.length} item for purchase</Typography>
</Box>
<Divider/>
   <Box sx={{backgroundColor:'#fff',display:'flex',justifyContent:'space-between'}}>
   <Typography sx={{m:2,fontSize:16,fontWeight:'bold'}}>Total payable amount</Typography>
   <Typography sx={{m:2,fontSize:16,fontWeight:'bold'}} >{(parseInt(sum)).toLocaleString('en-US', {
                                   style: 'currency',
                                   currency: 'INR',
                                    })}</Typography>
   </Box>
<Divider/>
<Box sx={{backgroundColor:'#fff',display:'flex',justifyContent:'space-between'}}>
<Typography sx={{m:2,fontSize:16,fontWeight:'bold'}}>Total</Typography>
<Typography sx={{m:2,fontSize:16,fontWeight:'bold'}} >{(parseInt(sum)).toLocaleString('en-US', {
                                   style: 'currency',
                                   currency: 'INR',
                                    })}</Typography>
</Box>

<Box sx={{backgroundColor:'#e1e9e9',display:'flex',justifyContent:'left',}}>
<Typography sx={{m:2,fontSize:16,fontWeight:'bold'}}>Please Confirm Your Booking</Typography>
</Box>

<Box sx={{backgroundColor:'#fff',display:'flex',justifyContent:'left', '&:hover': {
    backgroundColor: '#5cd1d5',
   
  },}}>
<Typography sx={{m:2,fontSize:16,fontWeight:'bold'}}>Online payment</Typography>
</Box>
<Box sx={{backgroundColor:'#e9efef'}}>
<br/>

<Box sx={{display:'flex'}}>
<Box onClick={this.payCash} sx={{width:'50%'}} >
<Box sx={{backgroundColor:'#c7157a',display:'flex',justifyContent:'center',mt:1, }}>
<Typography sx={{m:1,fontSize:15,fontWeight:'500',color:'white'}}>Pay Cash</Typography>
</Box>
</Box>
<Box onClick={this.pay} sx={{width:'50%'}} >
<Box sx={{backgroundColor:'green',display:'flex',justifyContent:'center',mt:1, }}>
<Typography sx={{m:1,fontSize:15,fontWeight:'500',color:'white'}}>Pay Online</Typography>
</Box>
</Box>
</Box>



</Box>


   </Paper>
  </Grid>
</Grid>  










      </Box>
     </Container>
      </Box>
      <br/>
      <br/>
      </Box>
      </div>
    )
  }
}


export function FinalOrderc(props){
  const navigate = useNavigate();
  const location = useLocation();
  return (<FinalOrder location = {location} navigate={navigate}></FinalOrder>)
}


export default FinalOrder


